import { colors } from '@/theme/colors';

export default function BaseLoan() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1007_789)">
        <path
          d="M22.5 12C22.5001 11.2564 22.2633 10.5321 21.8241 9.93207C21.3848 9.33207 20.7659 8.88756 20.057 8.66299C20.4003 8.00283 20.5242 7.25044 20.4109 6.51505C20.2975 5.77965 19.9528 5.09951 19.4266 4.57337C18.9005 4.04722 18.2203 3.70245 17.4849 3.5891C16.7495 3.47574 15.9972 3.5997 15.337 3.94299C15.1127 3.23386 14.6682 2.61462 14.0682 2.17511C13.4682 1.7356 12.7438 1.49866 12 1.49866C11.2562 1.49866 10.5318 1.7356 9.93176 2.17511C9.33174 2.61462 8.88733 3.23386 8.66299 3.94299C8.00283 3.5997 7.25044 3.47574 6.51505 3.5891C5.77965 3.70245 5.09951 4.04722 4.57337 4.57337C4.04722 5.09951 3.70245 5.77965 3.5891 6.51505C3.47574 7.25044 3.5997 8.00283 3.94299 8.66299C3.23386 8.88733 2.61462 9.33174 2.17511 9.93176C1.7356 10.5318 1.49866 11.2562 1.49866 12C1.49866 12.7438 1.7356 13.4682 2.17511 14.0682C2.61462 14.6682 3.23386 15.1127 3.94299 15.337C3.5997 15.9972 3.47574 16.7495 3.5891 17.4849C3.70245 18.2203 4.04722 18.9005 4.57337 19.4266C5.09951 19.9528 5.77965 20.2975 6.51505 20.4109C7.25044 20.5242 8.00283 20.4003 8.66299 20.057C8.88733 20.7661 9.33174 21.3854 9.93176 21.8249C10.5318 22.2644 11.2562 22.5013 12 22.5013C12.7438 22.5013 13.4682 22.2644 14.0682 21.8249C14.6682 21.3854 15.1127 20.7661 15.337 20.057C15.9972 20.4003 16.7495 20.5242 17.4849 20.4109C18.2203 20.2975 18.9005 19.9528 19.4266 19.4266C19.9528 18.9005 20.2975 18.2203 20.4109 17.4849C20.5242 16.7495 20.4003 15.9972 20.057 15.337C20.7659 15.1124 21.3848 14.6679 21.8241 14.0679C22.2633 13.4679 22.5001 12.7436 22.5 12Z"
          stroke={colors.neutral10}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 7.50002H10.789C10.5492 7.48088 10.3081 7.51402 10.0824 7.59715C9.85662 7.68029 9.65161 7.81144 9.48151 7.98154C9.31141 8.15164 9.18026 8.35665 9.09712 8.58239C9.01399 8.80813 8.98085 9.04922 8.99999 9.28902C8.99999 11.25 15 12.75 15 14.711C15.0043 14.9472 14.961 15.1817 14.8727 15.4007C14.7843 15.6198 14.6527 15.8187 14.4857 15.9857C14.3187 16.1527 14.1197 16.2843 13.9007 16.3727C13.6817 16.4611 13.4471 16.5044 13.211 16.5H8.99999"
          stroke={colors.neutral10}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.5V5.25"
          stroke={colors.neutral10}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18.75V16.5"
          stroke={colors.neutral10}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1007_789">
          <rect width="24" height="24" fill={colors.neutral100} />
        </clipPath>
      </defs>
    </svg>
  );
}
